import { GtmEventInteractiveAction } from '../types';

const PERSONAL_DETAILS_ACTION_FIELD = {
  step: '1',
  option: 'Identification'
};

const SHIPPING_ACTION_FIELD = {
  step: '2',
  option: 'Type Delivery',
  action: GtmEventInteractiveAction.Checkout
};

const BILLING_ACTION_FIELD = {
  step: '3',
  option: 'Configure Payment',
  action: GtmEventInteractiveAction.Checkout
};

export {
  BILLING_ACTION_FIELD,
  PERSONAL_DETAILS_ACTION_FIELD,
  SHIPPING_ACTION_FIELD
};
